module.exports = __webpack_public_path__ + "static/10-5e7c676fa4a642455d44c080426663f7.jpg";